module.exports = __webpack_public_path__ + "static/media/vlado.28e8da78.jpg";